import React, { useRef, useState, useEffect} from "react";
import { Form, Button} from 'semantic-ui-react';
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { json, Link, useNavigate } from "react-router-dom";
import { HTTPURL} from "../constants/matcher";
import $ from 'jquery';
// import { HttpChild, Child } from "../Utils/HttpChild";
import {useFetchApi} from "../customHooks/useFetch";
import {Helmet} from "react-helmet";

export default function FormValidation() {
    const navigate = useNavigate();
    const [selected, setSelected] = useState(0);
    const [ministry, setMinistry] = useState([]);
    const [states, setStates] = useState([]);
    const [reqData, setreqData] = useState({}); // <-- add state
    const { resData } = useFetchApi(reqData); // <-- pass location value to hook

    useEffect( () => {
        if(Object.keys(resData).length !== 0){
            if(resData.status===true){
                sessionStorage.setItem('user_id', JSON.stringify(resData.data.insertId));
                toast.success(resData.message);
            }else{
               toast.error(resData.message)
            }
        }
        else{
            console.log("no res data.")
        }
        const fetchData = async () => 
        {
            return await fetch(HTTPURL+'user/get-all-category')
            .then((response) => response.json())
            .then((data) =>  {
                setMinistry(data.ministry);
                setStates(data.state);
            });
        }
        fetchData();
    }, [resData]);

    const {
        register,
        getValues,
        setValue,
        handleSubmit,
        formState: { errors },
        reset,
        watch,
    } = useForm();

    const password = useRef({});
    password.current = watch("password", "");

    function handleChange(event)
    {
        var value = event.target.value
        if(value == 0)
        {
            setSelected(0);
            $('.servantShow').show();
            $('.mentorShow').hide();
        } else{
            setSelected(1);
            $('.servantShow').hide();
            $('.mentorShow').show();
        }
    }

    const onSubmit = (data) => 
    {
        componentDidMount(data);
    }

    const componentDidMount = (requestData) =>
    {
        fetch(HTTPURL+'user/signup',
        {
            method: "POST",
            headers: {"Content-Type": "application/JSON"},
            body: JSON.stringify(requestData)
        })
        .then(res => res.json())
        .then(data => 
        {
            if(data.status===true){
                sessionStorage.setItem('user_id', JSON.stringify(data.data.insertId));
                navigate('/');
                toast.success(data.message);

            }else{
                toast.error(data.message)
            }
        })
        .catch(err => console.error(err));
    }

    return (
        
        <section className="h-100 bg-dark register-page">
            <Helmet>
                <title>Register page : - TMS</title>
            </Helmet>
            <div className="container py-5 h-100">
                <div className="row d-flex justify-content-center align-items-center h-100">
                    <div className="col">
                        <div className="card card-registration my-4">
                            <div className="row g-0">
                                <div className="col-xl-6 d-none d-xl-block register-left">
                                    <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-registration/img4.webp"
                                        alt="" className="img-fluid"
                                    />
                                </div>
                                <div className="col-xl-6 register-right" id="registrationForm">
                                    <Form onSubmit={handleSubmit(onSubmit)}>
                                        <div className="card-body p-md-5 text-black">
                                            <h3 className="mb-5 text-uppercase">Registration form</h3>
                                            
                                            <div className="row">
                                                <div className="col-md-6 mb-4">
                                                    <div className="form-outline">
                                                        <div className="d-md-flex justify-content-start align-items-center mb-4 py-2">
                                                            <Form.Field>
                                                                <label className="form-label" htmlFor="userType">User Type</label>

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        {...register("userType", { required: true })}
                                                                        type="radio"
                                                                        value="0"
                                                                        id="servant"
                                                                        className="form-check-input"
                                                                        onChange={handleChange}
                                                                        checked={selected === 0}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="servant">Civil Servant</label>
                                                                </div>

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        {...register("userType", { required: true })}
                                                                        type="radio"
                                                                        value="1"
                                                                        id="mentor"
                                                                        className="form-check-input"
                                                                        onChange={handleChange}
                                                                        checked={selected === 1}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="mentor">Mentor</label>
                                                                </div>
                                                            </Form.Field>
                                                        </div>
                                                        {errors.userType && errors.userType.type === "required" && <span className="validation-error">This is required</span>}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6 mb-4">
                                                    <div className="form-outline">
                                                        <Form.Field>
                                                            <label className="form-label" htmlFor="form3Example1m">First name</label>
                                                            <input
                                                                placeholder='First Name'
                                                                type="text"
                                                                {...register("firstName", { required: true, maxLength: 20 })}
                                                                className="form-control form-control-lg"
                                                            />
                                                        </Form.Field>
                                                        {errors.firstName && errors.firstName.type === "required" && <span className="validation-error">This is required</span>}
                                                        {errors.firstName && errors.firstName.type === "maxLength" && <span className="validation-error">Max length is 20</span>}
                                                    </div>
                                                </div>

                                                <div className="col-md-6 mb-4">
                                                    <div className="form-outline">
                                                        <Form.Field>
                                                            <label className="form-label" htmlFor="form3Example1m">Middle name</label>
                                                            <input
                                                                placeholder='Middle Name'
                                                                type="text"
                                                                {...register("middleName", { required: true, maxLength: 20 })}
                                                                className="form-control form-control-lg"
                                                            />
                                                        </Form.Field>
                                                        {errors.middleName && errors.middleName.type === "required" && <span className="validation-error">This is required</span>}
                                                        {errors.middleName && errors.middleName.type === "maxLength" && <span className="validation-error">Max length is 20</span>}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6 mb-4">
                                                    <div className="form-outline">
                                                        <Form.Field>
                                                            <label className="form-label" htmlFor="form3Example1m">Last name</label>
                                                            <input
                                                                placeholder='Last Name'
                                                                type="text"
                                                                {...register("lastName", { required: true, maxLength: 20 })}
                                                                className="form-control form-control-lg"
                                                            />
                                                        </Form.Field>
                                                        {errors.lastName && errors.lastName.type === "required" && <span className="validation-error">This is required</span>}
                                                        {errors.lastName && errors.lastName.type === "maxLength" && <span className="validation-error">Max length is 20</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div className="row">
                                                <div className="col-md-6 mb-4">
                                                    <div className="form-outline">
                                                        <div className="form-outline">
                                                            <Form.Field>
                                                                <label className="form-label" htmlFor="form3Example1m">Phone Number</label>
                                                                <input
                                                                    placeholder='Phone Number'
                                                                    type="text"
                                                                    {...register("phone", { required: true, maxLength: 11})}
                                                                    className="form-control form-control-lg"
                                                                />
                                                            </Form.Field>
                                                            {errors.phone && errors.phone.type === "required" && <span className="validation-error">This is required</span>}
                                                            {errors.phone && errors.phone.type === "maxLength" && <span className="validation-error">Max length is 11</span>}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6 mb-4">
                                                    <div className="form-outline">
                                                        <div className="form-outline">
                                                            <Form.Field>
                                                                <label className="form-label" htmlFor="Email Address">Email Address</label>
                                                                <input
                                                                    placeholder='Email Address'
                                                                    type="email"
                                                                    {...register("email",
                                                                        {
                                                                            required: true,
                                                                            //eslint-disable-next-line
                                                                            pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                                                                        })}
                                                                    className="form-control form-control-lg"
                                                                />
                                                            </Form.Field>
                                                            {errors.email && errors.email.type === "required" && <span className="validation-error">This is required</span>}
                                                            {errors.email && errors.email.type === "pattern" && <span className="validation-error">Must be a valid email</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row servantShow">
                                                <div className="col-md-6 mb-4">
                                                    <div className="form-outline">
                                                        <div className="form-outline">
                                                            <Form.Field>
                                                                <label className="form-label" htmlFor="Ministry">Ministry</label>
                                                                <select
                                                                    {...register("ministry")}
                                                                >
                                                                <option value="">Select</option>
                                                                {
                                                                    ministry && ministry.map((mini, index) => {
                                                                        return  <option key={index} value={mini.id}>{mini.name}</option>
                                                                    })
                                                                }
                                                                </select>
                                                            </Form.Field>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6 mb-4">
                                                    <div className="form-outline">
                                                        <div className="form-outline">
                                                            <Form.Field>
                                                                <label className="form-label" htmlFor="Ministry">State</label>
                                                                <select
                                                                    {...register("state")}
                                                                >
                                                                <option value="">Select</option>
                                                                {
                                                                    states && states.map((state,index) => {
                                                                        return <option key={index} value={state.id}>{state.name}</option>
                                                                    })
                                                                }
                                                                </select>
                                                            </Form.Field>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6 mb-4">
                                                    <div className="form-outline">
                                                        <div className="form-outline">
                                                            <Form.Field>
                                                                <label className="form-label" htmlFor="Password">Password</label>
                                                                <input
                                                                    placeholder='Password'
                                                                    type="password"
                                                                    {...register("password", {
                                                                        required: true,
                                                                        pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,15}$/
                                                                    })}
                                                                    className="form-control form-control-lg"
                                                                />
                                                            </Form.Field>
                                                            {errors.password && errors.password.type === "required" && <span className="validation-error">This is required</span>}
                                                            {errors.password && errors.password.type === "pattern" && <span className="validation-error">At least 6 chars long,digit,upper case,lower case</span>}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6 mb-4">
                                                    <div className="form-outline">
                                                        <div className="form-outline">
                                                            <Form.Field>
                                                                <label className="form-label" htmlFor="Confirm Password">Confirm Password</label>
                                                                <input
                                                                placeholder='Confirm Password'
                                                                type="password"
                                                                {...register("confirmPassword", {
                                                                required: true,
                                                                validate: value =>
                                                                    value === password.current || "The passwords do not match"
                                                                })}
                                                                className="form-control form-control-lg"
                                                                />
                                                            </Form.Field>
                                                            {errors.confirmPassword && errors.confirmPassword.type === "required" && <span className="validation-error">This is required</span>}
                                                            {errors.confirmPassword && <p className="validation-error">{errors.confirmPassword.message}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div className="d-flex justify-content-end pt-3">
                                            <Button type="button" className="btn btn-light btn-lg sap-btn-light" onClick={() => reset()}>Reset</Button>
                                            <Button type='submit' className="btn btn-warning btn-lg ms-2 sap-btn-dark">Submit</Button>
                                            </div>

                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}